import { Toast as BaseToast } from '@base-ui/react/toast';
import type { ToastObject } from '@base-ui/react/toast';
import type { JSX } from 'react';
import { Button } from '../Button/Button.js';
import { ClearIcon } from '../assets/icons/ClearIcon.js';
import * as styles from './Toast.css.js';

export function ToastItem({
  toast,
  closeLabel,
}: {
  readonly toast: ToastObject<Record<string, unknown>>;
  readonly closeLabel: string;
}): JSX.Element {
  return (
    <BaseToast.Root toast={toast} className={styles.toast} data-slot="toast">
      <BaseToast.Content>
        <div className={styles.content}>
          <div className={styles.text}>
            <BaseToast.Title className={styles.title} />
            {toast.description ? <BaseToast.Description className={styles.description} /> : null}
          </div>
          <BaseToast.Close render={<Button variant="ghost" size="small" aria-label={closeLabel} />}>
            <ClearIcon />
          </BaseToast.Close>
        </div>
        <BaseToast.Action
          className={styles.action}
          data-slot="toast-action"
          render={<Button variant="outline" />}
        />
      </BaseToast.Content>
    </BaseToast.Root>
  );
}
